import { Box } from "@mui/material";

import { Text } from "../../../components/Text";

interface NavigationMenuSectionTitleDesktopProps {
  children: React.ReactNode;
}

export function NavigationMenuSectionTitleDesktop(props: NavigationMenuSectionTitleDesktopProps) {
  const { children } = props;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        paddingTop: 6,
        paddingBottom: 3,
        paddingX: 2,
        gap: 3,
      }}
    >
      <Text
        variant="body2"
        sx={(theme) => ({
          color: theme.palette.navbar?.sectionTitle,
          flexShrink: 0,
          whiteSpace: "nowrap",
          fontWeight: theme.palette.navbar?.menuItemBold
            ? theme.typography.fontWeightBold
            : theme.typography.fontWeightRegular,
        })}
      >
        {children}
      </Text>

      <Box
        sx={(theme) => ({
          height: "1px",
          backgroundColor: theme.palette.navbar?.sectionDivider,
          flexGrow: 1,
        })}
      />
    </Box>
  );
}
